import { IEntity } from './IEntity';

export interface IRadioStation extends IEntity {
	url: string;
	volume: number;
}

export const resourceNameRadioStation = `radiostation`;
